export default __webpack_public_path__ + "static/media/a6.0bcf3ba2.png";